import View from '../../view';

import { hashify } from '../../../utils/arrays';





export default View.extend( {

    serialize() {
        const { datatables, group: { objects, types } } = this.options;
        const datatablesHash = hashify( datatables, datatable => [datatable.id, datatable] );

        return {
            types,
            objects: objects.map( ({ layer_id, ...attrs }) => ({
                datatable: datatablesHash[layer_id],
                ...attrs,
            }) ),
        };
    },

} );








// WEBPACK FOOTER //
// ./src/js/view/module/contracts/group.js